"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkdownOverlayEditorStyle = void 0;

var _styles = require("../../common/styles");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    min-width: ", "px;\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    position: relative;\n    color: ", ";\n\n    .edit-icon {\n        position: relative;\n        cursor: pointer;\n\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        color: ", ";\n\n        padding: 0;\n\n        height: 24px;\n        width: 24px;\n        flex-shrink: 0;\n\n        transition: all \"0.125s ease\";\n\n        border-radius: 6px;\n\n        > * {\n            width: 16px;\n            height: 16px;\n        }\n    }\n\n    .edit-hover {\n        :hover {\n            background-color: ", ";\n        }\n    }\n\n    .checkmark-hover {\n        :hover {\n            color: #ffffff;\n            background-color: ", ";\n        }\n    }\n\n    .md-edit-textarea {\n        position: relative;\n        top: 0px;\n        left: 0px;\n        width: 0px;\n        height: 0px;\n        margin-top: 25px;\n        opacity: 0;\n        padding: 0;\n    }\n\n    .ml-6 {\n        margin-left: 6px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* buttonVNext 
        variant: accent
        style:   minimal
        size:    xsm
        iconOnly
        toggle to primary
    */
var MarkdownOverlayEditorStyle = _styles.styled.div(_templateObject(), function (p) {
  return p.targetRect.width;
}, function (p) {
  return p.theme.fgColorDark;
}, function (p) {
  return p.theme.b400;
}, function (p) {
  return p.theme.b300;
}, function (p) {
  return p.theme.b400;
});

exports.MarkdownOverlayEditorStyle = MarkdownOverlayEditorStyle;